<template>
  <header id="top">
    <div
      class="top-user_menu"
      v-bind:class="{ active: showMenu }"
      v-on:click="showMenu = !showMenu"
    >
      <div id="top-user_button">
        {{this.username}}
        <div class="top-drop_arrow" />
      </div>
      <ul class="subList">
        <li class="subList__item" v-on:click="logout()">logout</li>
      </ul>
    </div>
  </header>
</template>

<script>

export default {
  name: 'top',
  data() {
    return {
      username: this.$store.state.user,
      showMenu: false,
    };
  },
  methods: {
    logout() {
      this.$router.replace('/logout');
    },
  },
};
</script>

<style>

/* persistent header */
#top {
  position: absolute;
  top: 0;
  right: 0;
  height: 38px;
  left: 500px;
}
  .page-wide #top {
    left: 228px;
  }
  .top-user_menu {
    position: absolute;
    top: 0;
    right: 0;
    height: 42px;
    line-height: 42px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.2s all ease;
    background-color: #f7f7f7;
    z-index: 30;
  }
    .top-user_menu:hover {
      background-color: #eee;
    }
    #top-user_button {
      background-color: #eee8ec;
      z-index: 10;
      font-size: 16px;
      padding: 0 40px;
    }
      .top-drop_arrow {
        display: inline-block;
        background-image: url('~@/assets/arrow/orange.png');
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: 4px;
        width: 10px;
        height: 8px;
        transition: 0.2s all ease;
      }
    .top-user_menu .subList,
    .top-user_menu .subList__item {
      list-style: none;
      padding: 0;
    }
    .top-user_menu .subList {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      background: inherit;
      transition: 0.2s top ease;
      top: -2px;
    }
      .top-user_menu .subList__item {
        text-transform: uppercase;
        font-weight: 700;
        cursor: pointer;
        transition: 0.2s all ease;
      }
        .top-user_menu .subList__item:hover {
          background: #ddd;
        }
  /* active menu */
  .top-user_menu.active {
    background: #eee;
  }
    .top-user_menu.active .top-drop_arrow {
      transform: rotate(-180deg);
    }
    .top-user_menu.active .subList {
      top: 100%;
    }
</style>
